module.exports = __webpack_public_path__ + "static/knit-logo-57f3ea5c76e8888eb2202646234310bb.png";